import { useCallback } from 'react';

import Tooltip from '@mui/material/Tooltip';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { GridActionsCellItem } from '@mui/x-data-grid';

import type { FileItem } from './types/file-item.type';

interface MoveActionProps {
  readonly disabled: boolean;
  readonly file: FileItem;
  readonly onMove: (file: FileItem) => void;
}

export const MoveAction = ({
  disabled,
  file,
  onMove,
}: Readonly<MoveActionProps>) => {
  const handleClick = useCallback(() => {
    onMove(file);
  }, [file, onMove]);

  const actionLabel = 'Changer de catégorie';

  return (
    <GridActionsCellItem
      disabled={disabled}
      icon={
        <Tooltip title={actionLabel}>
          <DriveFileMoveIcon fontSize="inherit" />
        </Tooltip>
      }
      label={actionLabel}
      onClick={handleClick}
    />
  );
};
